import { render } from "./ProcenaEdukacijeIzvestaj.vue?vue&type=template&id=3ea4d178&scoped=true&lang=html"
import script from "./ProcenaEdukacijeIzvestaj.vue?vue&type=script&lang=js"
export * from "./ProcenaEdukacijeIzvestaj.vue?vue&type=script&lang=js"

import "./ProcenaEdukacijeIzvestaj.vue?vue&type=style&index=0&id=3ea4d178&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-3ea4d178"

export default script